import {createRouter, createWebHistory} from 'vue-router'

const constantRoutes = [{
    path: '/qa', name: "qa", component: () => import('@/pages/qa/qa-page'),
}, {
    path: '/qa/result', name: "qa-result", component: () => import('@/pages/qa/qa-result.vue'),
}];

const router = createRouter({
    history: createWebHistory(), routes: constantRoutes,
});

export default router;